isEventsDetailsPage